import { PropsWithChildren } from "react";

import layoutStyles from "./Layout.module.css";

type Props = {};

export const Content = ({ children }: PropsWithChildren<Props>) => {
  return <div className={layoutStyles.content}>{children}</div>;
};
